module.exports = __webpack_public_path__ + "img/utsuho reiuji_sc1.2cd176fc.png";